import { useGetUserSettingsQuery } from '../graphql/advisor/generates';
import { getGraphQLClient } from '../graphql/graphQLClient';
import { CodeType } from '../screen/SettingPage/types';

export const useGetSettingList = () =>
  useGetUserSettingsQuery(getGraphQLClient('advisor'), undefined, {
    select: (userSettings) =>
      userSettings.user.settings.map((setting) => ({ ...setting, code: setting.code as CodeType })),
  });
